<template>
    <div>
        <div id="divPecas" class="container row">
            <div class="testePopUp" :style="displayQrCode">
                <video :id="'videoPeca' + index"></video>
                <button class="btn btnCloseQrCode" @click="displayQrCode = 'display:none;'">X</button>
            </div>
            <div class="col-12 col-sm-6">
                <label for="label-items">{{ $t('Serviços') }}: </label>
                <div v-if="!exibePreco">
                    <v-select id="label-items" class="mb-3" :disabled="disabledPeca" :options="materiais()" v-model="selectItem"
                        :placeholder="this.$t('Serviços')"></v-select>
                </div>
                <div v-if="exibePreco">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control mr-2" v-model="selectItemTemp" placeholder="Pesquisar serviço" />
                        <button class="btn btn-primary" @click="performSearch">Pesquisar</button>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="showListItens">
                <ul class="list-group">
                    <li v-for="item in filteredOptions" :key="item.nr_sequencial" class="list-group-item" style="display: flex; align-items: center; justify-content: space-between;">
                        {{ item.ds_item }} <button class="btn btn-primary"
                            @click="selectItemFromList(item)">Selecionar</button>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-sm-6 row">
                <div class="col-sm-6 col-10">
                    <div class="">
                        <label for="label-quantidade">{{ $t('Quantidade') }} : </label>
                        <input type="number" id="label-quantidade" class="form-control" v-model="quantidade"
                            :disabled="disabledPeca">
                    </div>
                </div>
                <div class="col-sm-6  col-10" v-if="exibePreco">
                    <div class="">
                        <label for="label-preco">{{ $t('Preço') }}: </label>
                        <input type="number" id="label-preco" class="form-control" v-model="preco"
                            :disabled="disabledPeca">
                    </div>
                </div>

                <div class="col-2 d-flex " style="align-items: center; padding-top: 20px;">
                    <button :disabled="disabledPeca" class="btn btn-success btn-block mb-2 mr-2 btnAcaoPecas"
                        @click="createItem()">
                        <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="col-2 d-flex " style="align-items: center; padding-top: 20px;">
                    <button class="btn btn-danger btn-block mb-2 ml-2 btnAcaoPecas" @click="deleteItem()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
                <!-- <div class="col-2 d-flex " style="align-items: center; padding-top: 20px;">
                    <button class="btn btn-outline-success mb-2 ml-2 pb-2" @click="qrCode()">
                        <i class="fa fa-camera" aria-hidden="true"></i>
                    </button>
                </div> -->

            </div>
        </div>
        <hr>
    </div>
</template>
<script>
/* eslint-disable */
// import Instascan from 'instascan';

export default {
    name: 'AddPecaComponent',
    props: {
        itemDelete: {},
        nrConjunto: {},
        itemProp: {},
        os: {},
        index: {}
    },
    data() {
        return {
            showListItens: false,
            quantidade: 0,
            preco: 0,
            selectItem: '',
            disabledPeca: false,
            nr_sequencial: '',
            nr_sequencial_item: '',
            nr_sequencial_problema: '',
            disablecDelete: true,
            item: {},
            showModalItem: false,
            screenQrCode: false,
            displayQrCode: 'display:none',
            itemModal: null,
            itemFiltro: '',
            limparFiltro: false,
            inventario_atual: false,

            allMateriais: [], // para armazenar todos os materiais
            filteredOptions: [], // para armazenar as opções filtradas
            materiaisArray: [],
            selectItemTemp: ''
        }
    },
    computed: {
        // materiais() {
        //     return this.$store.getters['frotaItem/materiais']
        // },  
        exibePreco() {
            // try {
            if (this.os.st_origem === 'E') {
                return true
            } else {
                return false
            }
            // } catch (error) {
            //     return false
            // }
        },
    },

    watch: {
        materiais(newVal) {
            if (newVal) {
                this.allMateriais = newVal.map(material => ({
                    ...material,
                    label: material.ds_codigoitem != null
                        ? `${material.ds_codigoitem} - ${material.ds_item}`
                        : material.ds_item
                }))
                this.filteredOptions = this.allMateriais.slice(0, 100) // Limite inicial para melhorar a performance
            }
        }
    },

    methods: {
        performSearch() {
            this.showListItens = true
            if (this.selectItemTemp) {
                this.filteredOptions = this.materiaisArray.filter(material =>
                    material.ds_item.toLowerCase().includes(this.selectItemTemp.toLowerCase())
                )
                console.log(this.filteredOptions)
            } else {
                this.filteredOptions = [] // Limpar a lista se a consulta estiver vazia
            }
        },
        selectItemFromList(item) {
            this.showListItens = false
            this.selectItemTemp = item.ds_item
            this.selectItem = item
        },
    
        materiais() {
            const materiais = this.$store.getters['frotaItem/servicos']

            if (materiais) {
                return materiais.map(material => {
                    return {
                        ...material,
                        label: material.ds_codigoitem != null ? material.ds_codigoitem + ' - ' + material.ds_item : material.ds_item
                    }
                })
            } else {
                return []
            }
        },
        async qrCode() {
            this.displayQrCode = 'display:flex'

            const scanner = new Instascan.Scanner({
                video: document.querySelector('#videoPeca'+this.index)
            })

            scanner.addListener('scan', content => {
                this.displayQrCode = 'display:none;'
                this.itemModal = content
                console.log(content)
                const materiais = this.$store.getters['frotaItem/materiais']

                const material = materiais.find(el => el.ds_codigoitem == content)

                // const material = materiais.map(material => {
                //     if(material.ds_codigoitem == content){
                //         return {
                //             ...material,
                //             label: material.ds_codigoitem != null ? material.ds_codigoitem + ' - ' + material.ds_item : material.ds_item
                //         }
                //     }
                // })

                const data = {
                    ...material,
                    label: material.ds_codigoitem != null ? material.ds_codigoitem + ' - ' + material.ds_item : material.ds_item
                }

                this.selectItem = data
                  
                scanner.stop()
            })

            Instascan.Camera.getCameras().then((cameras) => {
                let selectedCamera;

                if (cameras.length > 0) {
                    // scanner.start(cameras[2]);
                    for (let c = 0; c < cameras.length; c++) {
                        if (cameras[c].name.indexOf('back') != -1) {
                            selectedCamera = cameras[c];
                        }
                    }

                    if (!selectedCamera) selectedCamera = cameras[0];
                    scanner.start(selectedCamera);
                } 

                if (selectedCamera) {
                    scanner.start(selectedCamera);
                } else {
                    console.error("No cameras found.");
                }
            })
        },


        refreshItem() {
            console.log(this.nrConjunto)
            this.$store.dispatch('frotaItem/fetchFromMateriais', { nrOs: this.nrConjunto }).then(response => {
            })
        },

        validadeItem() {
            if (!(this.selectItem.nr_sequencial && parseFloat(this.quantidade))) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Insira todas as informações!',
                    icon: 'error'
                })
            } else {
                return true
            }
        },
        createItem() {
            console.log(this.selectItem)
            if (this.validadeItem()) {
                this.disabledPeca = true
                // console.log(this.selectItem)
                const data = {
                    nr_os: this.$route.params.id,
                    nr_sequencial: this.selectItem.nr_sequencial,
                    quantidade: parseFloat(this.quantidade),
                    precoTotal: this.preco,
                    precoUnit: this.preco / parseFloat(this.quantidade)
                }

                this.$store
                    .dispatch('osItem/insertPeca', { data: data }).then(response => {
                        this.nr_sequencial_os_item = response.data.nr_sequencial
                        this.nr_sequencial_item = response.data.nr_seq_item


                        this.disablecDelete = false
                        this.$swal.fire({
                            title: this.$t('Sucesso'),
                            text: 'Item registrado com sucesso!',
                            icon: 'success'
                        })
                        this.$store
                            .dispatch('osItem/fetchFromApi', {
                            nrSeqOs: this.$route.params.id
                        })
                    })


            }
        },
        deleteItem() {
            const filial = this.$store.getters['filial/filial']

            const nr_seq_clifor = filial.tecnicoId
            const execucao = {
                nr_seq_os: this.$route.params.id,
                nr_sequencial: this.nr_sequencial_os_item,
                nr_seq_item: this.nr_sequencial_item,
                nr_seq_clifor: nr_seq_clifor
            }

            this.$store
                .dispatch('frotaItem/deletePeca', { data: execucao }).then(response => {
                    this.disabledPeca = false
                    this.$swal.fire({
                        title: this.$t('Sucesso'),
                        text: 'Item excluído com sucesso!',
                        icon: 'success'
                    })
                }).catch(error => {
                    console.log(error)
                })

            this.$destroy();
            this.$el.parentNode.removeChild(this.$el);
        }
    },
    created() {
        if (this.itemProp) {
            this.nr_sequencial_os_item = this.itemProp.nr_sequencial_item
            this.nr_sequencial_item = this.itemProp.nr_sequencial
            this.selectItem = this.itemProp.ds_item
            this.selectItemTemp = this.itemProp.ds_item
            this.quantidade = parseFloat(this.itemProp.qt_quantidade)
            this.preco = this.itemProp.vl_total
        }
        if (!this.item) {
            this.disabledPeca = false
        }
        this.materiaisArray = this.$store.getters['frotaItem/servicos']

        // const materiaisTemp = this.$store.getters['frotaItem/materiais']
        // Inicialmente carregar uma quantidade limitada de itens para não travar a interface
        if (this.materiaisArray.length) {
            this.filteredOptions = this.materiaisArray.slice(0, 100).map(material => ({
                ...material,
                label: material.ds_codigoitem != null
                    ? `${material.ds_codigoitem} - ${material.ds_item}`
                    :  material.ds_item
            }))
        }
    }
}
</script>
<style>
    .btnAcaoPecas {
        display: flex;
        justify-content: center;
        padding: 10px 18px;
    }

    #videoAddPeca {
        transform: scaleX(1) !important;
    }

    @media screen and (max-width: 980px) {
        #videoAddPeca {
            width: 333px !important;
            height: 270px !important;
        }
    }

    .testePopUp {
        background-color: #0000008f;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1050;
        display: initial;
        width: 100%;
        height: 100%;
        overflow: hidden;
        outline: 0;
        justify-content: center;
        align-items: center;
    }

    .icones {
        font-size: 20px;
        padding: 0px;
        width: 53px;
        height: 53px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50% !important;
    }

    .btnCloseQrCode {
        background-color: #ffffffc4;
        width: 35px;
        position: absolute;
        height: 35px;
        top: 20px;
        right: 20px;
    }
</style>